import React, {useState, useEffect, useContext} from 'react';
import classes from './Partners.module.scss';
import socar from './logos/socar.png';
import bakcell from './logos/bakcell.png';
import ada from './logos/ada.png';
import azercell from './logos/azercell.png';
import rabitabank from './logos/rabitabank.png';
import pashabank from './logos/pashabank.png';
import bp from './logos/bp.png';
import kapital from './logos/kapital.png';
import azal from './logos/azal.png';

import socarL from './logos/socar-little.png';
import bakcellL from './logos/bakcell-little.png';
import adaL from './logos/ada-little.png';
import azercellL from './logos/azercell-little.png';
import rabitabankL from './logos/rabitabank-little.png';
import pashabankL from './logos/pashabank-little.png';
import bpL from './logos/bp-little.png';
import kapitalL from './logos/kapital-little.png';
import azalL from './logos/azal-little.png';

import Select from 'react-select';
import Autocomplete from 'react-autocomplete-select'
import axios from 'axios';
import {isMobileOnly} from 'react-device-detect';

import InputMask from 'react-input-mask'

import { useForm } from "react-hook-form";

import {Modal} from '../Modal/Modal'

import { requests } from '../../services/requests';

import { LanguageContext, Text } from '../../containers/Language';

const Partners = () => {

    const {dictionary} = useContext(LanguageContext);

    const [company, setcompany] = useState(null);
    const [partnerCount, setPartnerCount] = useState(0);
    const [customerCount, setCustomerCount] = useState(null);
    const [success, setSuccess] = useState(false);

    const [inputValue, setValue] = useState('');
    const [selectedValue, setSelectedValue] = useState(null);

    const [disabled, setDisabled] = useState(false);
    const [error, setError] = useState(false);


     // handle input change event
    const handleInputChange = value => {
        setValue(value);
    };

      // handle selection
    const handleChange = value => {
        setSelectedValue(value);
    }

    const { register, handleSubmit, formState: { errors }, reset } = useForm();

    const onSubmit = form => companyForm(form);
    
    const companyForm = async (data) => {

        requests.newcompany(data).then((res) => {
            if(res.status === 200){
                setSuccess(true)
                setDisabled(false)
                setError(false)
            }
        })
        .catch(() =>{
            setSuccess(false)
            setDisabled(false)
            setError(true)
        });

       
        reset({});
    };

    useEffect(() => {

        const getCompanies = async () => {
            const resp = await requests.companies();
            setcompany(
                resp.map((data, id) => {
                    return {value: id, label: data.companyName}
                })
            );
            setPartnerCount(resp.length);
        };

        !company && getCompanies();

        const getCustomerCount = async () => {
            const resp = await requests.customers();
            setCustomerCount(resp);
        };

        !customerCount && getCustomerCount();

    }, []);

    return (
        <div className={classes.Partners}>
            <div className='container'>
                <p dangerouslySetInnerHTML={{__html: dictionary.PARTNERS_TEXT.replace('{partnerCount}', partnerCount).replace('{customerCount}', customerCount)}} className={classes.parnersCount}>
                </p>

                <div className={classes.partnersList}>
                        <img src={isMobileOnly ? socarL : socar} alt='Logo' />

                        <img src={isMobileOnly ? bakcellL : bakcell} alt='Logo' />

                        <img src={isMobileOnly ? adaL : ada} alt='Logo' />

                        <img src={isMobileOnly ? azercellL : azercell} alt='Logo' />

                        <img src={isMobileOnly ? pashabankL : pashabank} alt='Logo' />

                        <img src={isMobileOnly ? bpL : bp} alt='Logo' />

                        <img src={isMobileOnly ? rabitabankL : rabitabank} alt='Logo' />
                    
                        <img src={isMobileOnly ? kapitalL : kapital} alt='Logo' />

                        <img src={isMobileOnly ? azalL : azal} alt='Logo' />
                </div>

                <div className={classes.companyLine}>
                    <div className={classes.companyList}>
                        <p><Text tid="COMPANY_LIST" /></p>
                        {/* <Select className={classes.companySelect}
                            isSearchable={true}
                            isClearable={true}
                            placeholder="Şirkətlər"
                            options={company} /> */}


                    <Autocomplete
                        searchPattern={'containsString'} 
                        selectOnBlur = {false}    
                        placeholder = {dictionary.ENTER_COMP_NAME}
                        searchEnabled = {true} 
                        getItemValue={(item)=>{ return item.label }} 
                        itemsData = {company}
                        globalStyle="
                        .autocomplete {
                            position: relative;
                            display: inline-block;
                            width: 250px;
                            background-color: transparent;
                        }

                        input {
                            border: 1px solid #dddddd;
                            background-color: white;
                            padding: 10px;
                            font-size: 14px;
                            border-radius: 6px;
                        }

                        input:focus{
                            outline: none;
                        }

                        .___optionsDiv___ div {
                            font-size: 14px;
                        }

                        @media only screen and (max-width: 1199px){
                            .autocomplete {
                                width: 200px;
                            }
                        }

                        @media only screen and (max-width: 575px){
                            .autocomplete {
                                width: 180px;
                            }
                        }

                        @media only screen and (max-width: 480px){

                            form{
                                width: 300px;
                            }

                            .autocomplete {
                                margin-top: 20px;
                                width: 100%;
                            }

                            input{
                                width: 100%;
                            }
                        }
                        "
                    />
                            
                    </div>

                    <p className={classes.companyApply}><Text tid="ADD_COMPANY_TXT" /> 
                        <span onClick={() => {setSuccess(false); reset({})}} data-bs-toggle="modal" data-bs-target="#companyApply"><Text tid="ADD_COMPANY_LINK" />  </span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12">
                            <g fill="none" fillRule="evenodd">
                                <g fill="#5959F5" fillRule="nonzero">
                                    <g>
                                        <g>
                                            <g>
                                                <path d="M432.75 15.125c.177 0 .333-.063.469-.188l4.625-4.453c.146-.135.219-.3.219-.492 0-.193-.073-.357-.22-.492l-4.593-4.438c-.146-.125-.313-.187-.5-.187-.188 0-.346.07-.477.21-.13.142-.195.306-.195.493 0 .188.073.35.219.484l3.375 3.25h-8.969c-.198 0-.367.073-.508.22-.14.145-.205.317-.195.515.01.177.083.328.219.453.135.125.291.188.469.188h8.953l-3.375 3.25c-.136.135-.206.296-.211.484-.006.187.06.349.195.484.135.146.302.219.5.219z" transform="translate(-1006 -1724) translate(95 1095) translate(0 245) translate(485 380)"/>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </p>

                    
                    <Modal success={success} id='companyApply' title={dictionary.PART_MODAL_TITLE}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="modal-body">
                                    <div className={`row ${classes.modalForm}`}>
                                        <div className='col-lg-6'>
                                            <div className="form-group">
                                                <label>{dictionary.NAME_SURNAME}</label>
                                                <input autoComplete='off' defaultValue="" {...register("CuratorName", { required: true })} 
                                                    disabled={disabled}
                                                    type="text" 
                                                    className={`form-control rounded ${errors.CuratorName && `is-invalid`}`} 
                                                    placeholder={dictionary.ENTER_NAME}/>
                                                {errors.CuratorName && <div className="error-notification">{dictionary.ERROR_REQUIRED}</div>}
                                            </div>
                                        </div>

                                        <div className='col-lg-6'>
                                            <div className="form-group">
                                                <label>{dictionary.MOB_NUM}</label>
                                                <InputMask
                                                    autoComplete='off' {...register("CuratorMobileNumber", { required: true })} 
                                                    className={`form-control rounded ${errors.CuratorMobileNumber && `is-invalid`}`}
                                                    mask="+(\9\94)-99-999-99-99"
                                                    disabled={disabled}
                                                    maskChar={null}
                                                    placeholder={dictionary.ENTER_NUM} />
                                                {errors.CuratorMobileNumber && <div className="error-notification">{dictionary.ERROR_REQUIRED}</div>}
                                            </div>
                                        </div>

                                        <div className='col-lg-6'>
                                            <div className="form-group">
                                                <label>{dictionary.COMP_NAME}</label>
                                                <input autoComplete='off' {...register("CompanyName", { required: true })} 
                                                    disabled={disabled}
                                                    type="text" 
                                                    className={`form-control rounded ${errors.CompanyName && `is-invalid`}`} 
                                                    placeholder={dictionary.ENTER_COMP_NAME}/>
                                                {errors.CompanyName && <div className="error-notification">{dictionary.ERROR_REQUIRED}</div>}
                                            </div>
                                        </div>
                                    </div>
                            </div>
                            <div className="modal-footer">
                                <button disabled={disabled} type="submit" className="btn btn-primary btn-lg rounded btn-shadow">{disabled ? (<><div class="spinner-border"></div> {dictionary.WAIT}</>) : dictionary.APPLY} </button>
                            </div>
                        </form>
                    </Modal>
                    
                </div>
            </div>

        </div>
    )
}

export default Partners
